// =============================================================================
//  Purpose   : lightweight query parser/stringifier for flat query objects
// =============================================================================
const hasOwn = (obj, key)=>Object.prototype.hasOwnProperty.call(obj, key);
const decode = (value)=>{
    let normalized = String(value).replace(/\+/g, ' ');
    try {
        return decodeURIComponent(normalized);
    } catch (_error) {
        return normalized;
    }
};
const encode = (value)=>encodeURIComponent(String(value));
export const parseQuery = (search)=>{
    let query = {};
    let source = String(search || '').replace(/^\?/, '');
    if (!source) {
        return query;
    }
    source.split('&').forEach((part)=>{
        if (!part) {
            return;
        }
        let idx = part.indexOf('=');
        let rawKey = idx < 0 ? part : part.slice(0, idx);
        let rawValue = idx < 0 ? null : part.slice(idx + 1);
        let key = decode(rawKey);
        let value = rawValue === null ? null : decode(rawValue);
        if (!hasOwn(query, key)) {
            query[key] = value;
            return;
        }
        if (Array.isArray(query[key])) {
            query[key] = [
                ...query[key],
                value
            ];
            return;
        }
        query[key] = [
            query[key],
            value
        ];
    });
    return query;
};
const addPart = (parts, encodedKey, value)=>{
    if (value === undefined) {
        return;
    }
    if (value === null) {
        parts.push(encodedKey);
        return;
    }
    parts.push(`${encodedKey}=${encode(value)}`);
};
export const stringifyQuery = (query)=>{
    if (!query) {
        return '';
    }
    let parts = [];
    Object.keys(query).sort().forEach((key)=>{
        let encodedKey = encode(key);
        let value = query[key];
        if (Array.isArray(value)) {
            value.forEach((v)=>addPart(parts, encodedKey, v));
        } else {
            addPart(parts, encodedKey, value);
        }
    });
    return parts.join('&');
};
